<template>
	<el-dropdown size="small" class="d2-mr">
		<span class="btn-text">{{info.name ?  ($t('Hello') + ` ${info.name}`) : $t('UnLogin') }}</span>
		<el-dropdown-menu slot="dropdown">			
			<el-dropdown-item @click.native="changePassword">
				<d2-icon name="key" class="d2-mr-5" />
				{{$t('uChangePassword')}}
			</el-dropdown-item>
			<el-dropdown-item @click.native="logOff">
				<d2-icon name="power-off" class="d2-mr-5" />
				{{$t('LogOut')}}
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import {
		UpdateMyPassword
	} from '@api/UserInfo.js'
	export default {
		computed: {
			...mapState('d2admin/user', [
				'info'
			])
		},
		methods: {
			...mapActions('d2admin/account', [
				'logout'
			]),
			/**
			 * @description 登出
			 */
			logOff() {
				this.logout({
					confirm: true
				})
			},
			//修改我的密码
			changePassword() {
				this.$prompt(this.$t('InputNewPassword'), this.$t('ChangePassword'), {
					confirmButtonText: this.$t('OK'),
					cancelButtonText: this.$t('Cancel'),
					inputPattern: /^[a-zA-Z]\w{5,17}$/,
					inputErrorMessage: this.$t('PasswordValid'),
					closeOnClickModal:false,
				}).then(({
					value
				}) => {
					UpdateMyPassword({
							Password: this.$md5(value)
						})
						.then(res => {
							this.$message.success(res)
						})
				}).catch(() => {})
			},
		}
	}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
